import { YEARLY_PIZZA_PRICE_USD } from '@/lib/constants';

const YEARS = Object.keys(YEARLY_PIZZA_PRICE_USD)
  .map(Number)
  .sort((a, b) => a - b);

const LEFT_COLUMN_ROWS = 10;

function formatPrice(year?: number) {
  if (!year) return '—';
  return `$${YEARLY_PIZZA_PRICE_USD[year].toFixed(2)}`;
}

export function YearlyPriceTable() {
  const leftYears = YEARS.slice(0, LEFT_COLUMN_ROWS);
  const rightYears = YEARS.slice(LEFT_COLUMN_ROWS, LEFT_COLUMN_ROWS * 2);

  return (
    <aside className="yearly-table" aria-label="Pizza price by year">
      <h3>Pizza price by year (USD)</h3>
      <p className="muted small">Inflation-adjusted yearly schedule. Split into two side-by-side year/price blocks.</p>
      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">Year</th>
              <th scope="col">Price</th>
              <th scope="col">Year</th>
              <th scope="col">Price</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: LEFT_COLUMN_ROWS }, (_, index) => {
              const left = leftYears[index];
              const right = rightYears[index];

              return (
                <tr key={index}>
                  <td>{left ?? '—'}</td>
                  <td>{formatPrice(left)}</td>
                  <td>{right ?? '—'}</td>
                  <td>{formatPrice(right)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </aside>
  );
}
